import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import ProfilePage from "@/components/account/profile-page";

const AccountProfilePage = (): JSX.Element => <ProfilePage />;

export const Route = createFileRoute("/_app/account/profile/")({
	component: AccountProfilePage,
});
